<div #dropdownOptionsBtn class="dropdown-container" (click)="handleDropdown()">
    <div class="d-flex align-items-center">
        <p [translatable]="{
            transKey: 'shared.addVariable',
            modEnum: translationModulesEnum.shared
          }">{{ 'shared.addVariable' | translate  }}</p>
        <i class="bx bx-dots-vertical-rounded"></i>
    </div>
  
    <angular-popper [show]="showDropDown" [target]="dropdownOptionsBtn" [positionFixed]="true">
      <div class="options-list" content>
        <div class="options-list-item" *ngFor="let variable of variables">
          <button class="btn-transparent" (click)="selectVariable(variable)">
            {{ lang === 'en' ? variable.name : variable.nameAr }}
          </button>
        </div>
      </div>
    </angular-popper>
</div>
